import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';
import { fg } from '@confluence/feature-gating';
import { LoadableAfterPaint } from '@confluence/loadable';

// Keep the machine registry graph out of the root App bundle. Flows start from
// user interaction, and a late mount reads the registry's current snapshot.
const LazyRemixWatcherHost = LoadableAfterPaint({
	name: 'RemixWatcherHost',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RemixWatcherHost" */ './RemixWatcherHost.tsx'))
			.RemixWatcherHost,
	loading: () => null,
});

export const RemixWatcherMount = (): React.JSX.Element => (
	<TransparentErrorBoundary attribution={Attribution.CE_MAU}>
		{/* Keep surface experiments at producer admission to avoid global renderer/editor exposure. */}
		{fg('remix_state_rearchitecture_enabled') ? <LazyRemixWatcherHost /> : null}
	</TransparentErrorBoundary>
);
